import { render, staticRenderFns } from "./ctrIndex.vue?vue&type=template&id=a25500a0&scoped=true&"
import script from "./ctrIndex.vue?vue&type=script&lang=js&"
export * from "./ctrIndex.vue?vue&type=script&lang=js&"
import style0 from "./ctrIndex.vue?vue&type=style&index=0&id=a25500a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25500a0",
  null
  
)

export default component.exports